export function lenisScroll() {
    if (!window.lenis && typeof Lenis !== 'undefined') {
        window.lenis = new Lenis({
            smooth: true,
            lerp: 0.08,           // 🔸 langzamer en soepeler
            smoothWheel: true,
            wheelMultiplier: 1, // 🔸 iets minder afstand per scroll
        });

        requestAnimationFrame(function raf(time) {
            window.lenis.raf(time);
            requestAnimationFrame(raf);
        });
    }
}
